//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'RequestWorkTypeIncludedInWorkPackagesIndicator',
  props: {
    workPackages: {
      type: Array,
      default () {
        return []
      }
    }
  }
}
